// Version : 0.0.1
// Author : AGALYA
// LastEdit : SATHISH
// LastAdd : chanegs for code review correction
// MODFIED DATE:06-11-2025

import { takeLatest, put, all, call } from 'redux-saga/effects';
import WorkFlowManagementActionTypes from './work-flow-management.types';
import {
	allRoleListForCreditAppraisal,
	creditAppraisalDetailsAdd,
	AllCreditAppraisalListGet,
	creditAppraisalDetailsDelete,
} from './work-flow-management.service';
import {
	getAllRoleDetailsSuccess,
	getAllRoleDetailsFailure,
	getAllRoleDetailsResponseChanged,
	addCreditAppraisalDetailsSuccess,
	addCreditAppraisalDetailsFailure,
	addCreditAppraisalDetailsResponseChanged,
	getAllCreditAppraisalDetailsSuccess,
	getAllCreditAppraisalDetailsFailure,
	getAllCreditAppraisalDetailsResponseChanged,
	deleteCreditAppraisalDetailsSuccess,
	deleteCreditAppraisalDetailsFailure,
	deleteCreditAppraisalDetailsResponseChanged,
} from './work-flow-management.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';

/** *********************  START GET ROLE LIST  ******************** */
export function* AllRoleDetailsListGet({ payload }: any) {
	try {
		const { companyID, databaseName } = payload;
		const key = 'FetchAllRoleListForCreditAppraisalListKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allRoleListForCreditAppraisal, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllRoleDetailsFailure(responseData.data));
		} else {
			yield put(getAllRoleDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllRoleDetailsFailure(error));
	}
}

export function* resetGetAllRoleListResponse() {
	yield put(getAllRoleDetailsResponseChanged());
}

export function* onGetAllRoleListDetails() {
	yield takeLatest(WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_START, AllRoleDetailsListGet);
}

export function* onGetAllRoleListResponseReset() {
	yield takeLatest(
		WorkFlowManagementActionTypes.GET_ALL_ROLE_LIST_RESPONSE_RESET,
		resetGetAllRoleListResponse,
	);
}
/** *********************  END GET ROLE LIST ******************** */

/** *********************  START ADD CENTER DETAILS  ******************** */
export function* createCreditAppraisal({ payload }: any) {
	try {
		const {
			appraisalType,
			screenName,
			questionairre,
			weightage,
			firstAppraisal,
			secondAppraisal,
			thirdAppraisal,
			fourthAppraisal,
			fifthAppraisal,
			noOfApproval,
			areaID,
			userID,
			databaseName,
			companyID,
		} = payload;
		const key = 'AddCreditAppraisalKey';
		const jsonData = {
			AppraisalType: appraisalType,
			ScreenName: screenName,
			Questionairre: questionairre,
			Weightage: weightage,
			FirstAppraisal: firstAppraisal,
			SecondAppraisal: secondAppraisal,
			ThirdAppraisal: thirdAppraisal,
			FourthAppraisal: fourthAppraisal,
			FifthAppraisal: fifthAppraisal,
			NoOfApproval: noOfApproval,
			AreaID: areaID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(creditAppraisalDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addCreditAppraisalDetailsFailure(responseData.data));
		} else {
			yield put(addCreditAppraisalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addCreditAppraisalDetailsFailure(error));
	}
}

export function* resetAddCreditAppraisalResponse() {
	yield put(addCreditAppraisalDetailsResponseChanged());
}

export function* onCreateCreditAppraisalDetails() {
	yield takeLatest(
		WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_START,
		createCreditAppraisal,
	);
}

export function* onCreateCreditAppraisalResponseReset() {
	yield takeLatest(
		WorkFlowManagementActionTypes.ADD_CREDIT_APPRAISAL_DETAILS_RESPONSE_RESET,
		resetAddCreditAppraisalResponse,
	);
}
/** *********************  END ADD CENTER DETAILS ******************** */

/** *********************  START GET ROLE LIST  ******************** */
export function* AllCreditAppraisalDetailsListGet({ payload }: any) {
	try {
		const { companyID, databaseName, userID } = payload;
		const key = 'GetAllCreditAppraisalListKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			UserID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(AllCreditAppraisalListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllCreditAppraisalDetailsFailure(responseData.data));
		} else {
			yield put(getAllCreditAppraisalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllCreditAppraisalDetailsFailure(error));
	}
}

export function* resetGetAllCreditAppraisalListResponse() {
	yield put(getAllCreditAppraisalDetailsResponseChanged());
}

export function* onGetAllCreditAppraisalListDetails() {
	yield takeLatest(
		WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_START,
		AllCreditAppraisalDetailsListGet,
	);
}

export function* onGetAllCreditAppraisalListResponseReset() {
	yield takeLatest(
		WorkFlowManagementActionTypes.GET_ALL_CREDIT_APPRAISAL_LIST_RESPONSE_RESET,
		resetGetAllCreditAppraisalListResponse,
	);
}
/** *********************  END GET ROLE LIST ******************** */

/** *********************  START DELETE CENTER DETAILS  ******************** */
export function* deleteCreditAppraisal({ payload }: any) {
	try {
		const { appraisalID, userID, databaseName, companyID } = payload;
		const key = 'DeleteCreditAppraisalKey';
		const jsonData = {
			AppraisalID: appraisalID,
			CreatedBy: userID,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(creditAppraisalDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteCreditAppraisalDetailsFailure(responseData.data));
		} else {
			yield put(deleteCreditAppraisalDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteCreditAppraisalDetailsFailure(error));
	}
}

export function* resetDeleteCreditAppraisalResponse() {
	yield put(deleteCreditAppraisalDetailsResponseChanged());
}

export function* onDeleteCreditAppraisalDetails() {
	yield takeLatest(
		WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_START,
		deleteCreditAppraisal,
	);
}

export function* onDeleteCreditAppraisalResponseReset() {
	yield takeLatest(
		WorkFlowManagementActionTypes.DELETE_CREDIT_APPRAISAL_DETAILS_RESPONSE_RESET,
		resetDeleteCreditAppraisalResponse,
	);
}
/** *********************  END DELETE CENTER DETAILS ******************** */

export function* workflowManagementSaga() {
	yield all([
		call(onGetAllRoleListDetails),
		call(onGetAllRoleListResponseReset),
		call(onCreateCreditAppraisalDetails),
		call(onCreateCreditAppraisalResponseReset),
		call(onGetAllCreditAppraisalListDetails),
		call(onGetAllCreditAppraisalListResponseReset),
		call(onDeleteCreditAppraisalDetails),
		call(onDeleteCreditAppraisalResponseReset),
	]);
}
